module.exports = __webpack_public_path__ + "static/media/header-photo1.034336b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/header-photo1.jpg
// module id = 322
// module chunks = 0